import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { doGetAccountBalance } from 'src/actions';
import { AccountBalance } from 'src/models';

import { CustomHookBaseOptions } from '../models/common.model';

import { useAccountSelector } from './useAccountSelector';
import { useBalanceSelector, UseBalanceSelectorReturnType } from './useBalanceSelector';

export interface UseAccountBalanceReturnType extends UseBalanceSelectorReturnType {}

export interface UseAccountBalanceOptions extends CustomHookBaseOptions {}

export const useAccountBalance = (
  { skip }: UseAccountBalanceOptions = { skip: false },
): UseAccountBalanceReturnType => {
  const dispatch = useDispatch();

  const { account } = useAccountSelector();
  const accountBalanceRaw: AccountBalance | undefined = useSelector(
    (state: any) => state.accountDetails.accountBalance?.data,
  );
  const { balance, isBalanceLoading, hasBalanceError, balanceError } = useBalanceSelector();
  useEffect(() => {
    if (!accountBalanceRaw && !isBalanceLoading && !skip && !hasBalanceError && account?.accountId) {
      dispatch(doGetAccountBalance(account.accountId));
    }
  }, [dispatch, account?.accountId]);

  return {
    balance,
    isBalanceLoading,
    hasBalanceError,
    balanceError,
  };
};
